import Navbar from "../Components/Navbar";
import Sidepanel from "../Savyn/Sidepanel";
import {
  Form,
  Row,
  Table,
  InputGroup,
  FormControl,
} from "react-bootstrap";

import { useState } from "react";
import gqlQuery from '../GQL';
import { useMutation } from "@apollo/client";
import { RowHistory } from "./Helpers";

const checkBoxCss = { marginLeft: "20px" };


const PatientHistory = ({ state, control, slide }) => {

  const [startTime] = useState(new Date().toISOString());
  const [answers, setAnswers] = useState({});
  const [addJSON] = useMutation(gqlQuery.addJSON);


  return (
    <>
     <Navbar state={state} control={control} slide={slide}/>
      <Row className="bg-img min-vh-100" >
      {/* <Container className="d-flex  justify-content-center vh-100 mh-100 "> */}
      <Sidepanel state={state} control={control} slide={slide}/>
      <div className="box text-left" style={{width:"800px"}}>
     
         
          
                   
          <h3>EMDR History</h3>
          <br />
          <Form>
            <Form.Group controlId="userName">
              <Form.Label>Name:</Form.Label>
              <Form.Control type="text" placeholder="Please type your name " 
              onChange={(e)=>{
                setAnswers({...answers, name:e.target.value})
              }}
              />
            </Form.Group>

            <Form.Group controlId="userAge">
              <Form.Label>Age:</Form.Label>
              <Form.Control type="text" placeholder="Please type your age" 
        onChange={(e)=>{
          setAnswers({...answers, age:e.target.value})
        }}
              />
            </Form.Group>

            <Form.Group controlId="familyStatus">
              <Form.Label>Family Status:</Form.Label>
              <Form.Control as="select"         onChange={(e)=>{
                setAnswers({...answers, family:e.target.value})
              }}
              >
                <option>Marrried</option>
                <option>In a relationship</option>
                <option>Common Law</option>
                <option>Single</option>
                <option>Married With Children</option>
                <option>Single With Children</option>
              </Form.Control>
            </Form.Group>

            <Form.Group controlId="userGender">
              <Form.Label>Gender:</Form.Label>
              <Form.Control type="text" placeholder="Please type your gender"        
              onChange={(e)=>{
                setAnswers({...answers, gender:e.target.value})
              }} />
            </Form.Group>

            <Form.Group controlId="userMedicalHistory">
              <Form.Label>
                History Questions
                <br />
                <span>Do you have any of the following conditions?</span>
              </Form.Label>

              <Form.Check
                style={checkBoxCss}
                type="checkbox"
                label="Heart Condition"
                onChange={(e)=>{
                  setAnswers({...answers, heartCondition:e.target.checked})
                }}
              />
              <Form.Check
                style={checkBoxCss}
                type="checkbox"
                label="Pregnant"
                onChange={(e)=>{
                  setAnswers({...answers, pregnant:e.target.checked})
                }}
              />
              <Form.Check
                style={checkBoxCss}
                type="checkbox"
                label="High blood pressure"
                onChange={(e)=>{
                  setAnswers({...answers, highBloodPressure:e.target.checked})
                }}
              />
              <Form.Check
                style={checkBoxCss}
                type="checkbox"
                label="Neurological brain conditions"
                onChange={(e)=>{
                  setAnswers({...answers, brainCondition:e.target.checked})
                }}
              />
              <Form.Check
                style={checkBoxCss}
                type="checkbox"
                label="Epilepsy"
                onChange={(e)=>{
                  setAnswers({...answers, epilepsy:e.target.checked})
                }}
              />
              <Form.Check
                style={checkBoxCss}
                type="checkbox"
                label="Eye Problems"
                onChange={(e)=>{
                  setAnswers({...answers, eyeProblems:e.target.checked})
                }}
              />
              <Form.Check
                style={checkBoxCss}
                type="checkbox"
                label="History of Drug and Alcohol Abuse"
                onChange={(e)=>{
                  setAnswers({...answers, alcholAbuse:e.target.checked})
                }}
              />
              <Form.Check
                style={checkBoxCss}
                type="checkbox"
                label="On medication for depression"
                onChange={(e)=>{
                  setAnswers({...answers, depression:e.target.checked})
                }}
              />
              <Form.Check
                style={checkBoxCss}
                type="checkbox"
                label="Dissociative Disorders"
                onChange={(e)=>{
                  setAnswers({...answers, dissociativeDisorder:e.target.checked})
                }}
              />
              <Form.Check
                style={checkBoxCss}
                type="checkbox"
                label="No To All"
                onChange={(e)=>{
                  setAnswers({...answers, noToAllMental:e.target.checked})
                }}
              />
            </Form.Group>

            <Form.Group controlId="userPersonal Stability">
              <Form.Label>
                Personal Stability
                <div>
                  Have you in the last 3 months undergone one of the following
                  life events?{" "}
                </div>
              </Form.Label>

              <Form.Check
                style={checkBoxCss}
                type="checkbox"
                label="Family Crisis"
                onChange={(e)=>{
                  setAnswers({...answers, familyCrisis:e.target.checked})
                }}
              />
              <Form.Check
                style={checkBoxCss}
                type="checkbox"
                label="Social Crisis"
                onChange={(e)=>{
                  setAnswers({...answers, socialCrisis:e.target.checked})
                }}
              />
              <Form.Check
                style={checkBoxCss}
                type="checkbox"
                label="Financial Problems"
                onChange={(e)=>{
                  setAnswers({...answers, finacialProblems:e.target.checked})
                }}
              />
              <Form.Check
                style={checkBoxCss}
                type="checkbox"
                label="Career Problems"
                onChange={(e)=>{
                  setAnswers({...answers, careerProblems:e.target.checked})
                }}
              />
              <Form.Check style={checkBoxCss} type="checkbox" label="Other" 
              
              onChange={(e)=>{
                setAnswers({...answers, otherProblems:e.target.checked})
              }}
              />
                    <Form.Check
                style={checkBoxCss}
                type="checkbox"
                label="No To All"
                onChange={(e)=>{
                  setAnswers({...answers, noToAllStability:e.target.checked})
                }}
              />
            </Form.Group>

            <Form.Group controlId="userRelationshipStatus">
              <Form.Label>Do you live alone?</Form.Label>

              <Form.Control as="select"  onChange={(e)=>{
                setAnswers({...answers, liveAlone:e.target.value})
              }}>
                <option>Yes</option>
                <option>No</option>
              </Form.Control>
            </Form.Group>

            <Form.Group controlId="userHomeSupport">
              <Form.Label>
                Do you have support at home in between sessions?
              </Form.Label>

              <Form.Control as="select" onChange={(e)=>{
                setAnswers({...answers, supportAtHome:e.target.value})
              }}>
                <option>Yes</option>
                <option>No</option>
              </Form.Control>
            </Form.Group>

            <Form.Group controlId="userSubstanceUse">
              <Form.Label>Do you use any of the following:</Form.Label>
              <Form.Check 
              style={checkBoxCss} 
              type="checkbox" 
              label="Alcohol" 
              onChange={(e)=>{
                setAnswers({...answers, useAlcohol:e.target.checked})
              }}
              />
              <Form.Check style={checkBoxCss} type="checkbox" label="Substance"
              
              onChange={(e)=>{
                setAnswers({...answers, useSubstance:e.target.checked})
              }}
              
              />
              <Form.Check 
              style={checkBoxCss} 
              type="checkbox" 
              label="Drugs" 
              onChange={(e)=>{
                setAnswers({...answers, useDrugs:e.target.checked})
              }}
              />
              <Form.Check
                style={checkBoxCss}
                type="checkbox"
                label="No To All"
                onChange={(e)=>{
                  setAnswers({...answers, noToAllSubstances:e.target.checked})
                }}
              />
            </Form.Group>
            <Form.Group controlId="substanceInterference">
              <Form.Label>
              Have you spent more time drinking or using than you intended to?
              </Form.Label>

              <Form.Control as="select" onChange={(e)=>{
                setAnswers({...answers, moreTimeDrinking:e.target.value})
              }}>
                <option>Yes</option>
                <option>No</option>
              </Form.Control>
            </Form.Group>
            <Form.Group controlId="substanceInterference">
              <Form.Label>
              Have you ever neglected some of your usual responsibilities because of using alcohol or drugs?
              </Form.Label>

              <Form.Control as="select" onChange={(e)=>{
                setAnswers({...answers, negelectedResponsibilities:e.target.value})
              }}>
                <option>Yes</option>
                <option>No</option>
              </Form.Control>
            </Form.Group>
            <Form.Group controlId="substanceInterference">
              <Form.Label>
              Have you felt you wanted or needed to cut down on your drinking or drug use in the last year?
              </Form.Label>

              <Form.Control as="select" onChange={(e)=>{
                setAnswers({...answers, cutDownOnDrinking:e.target.value})
              }}>
                <option>Yes</option>
                <option>No</option>
              </Form.Control>
            </Form.Group>
            <Form.Group controlId="substanceInterference">
              <Form.Label>
              Has your family, a friend, or anyone else ever told you they objected to your alcohol or drug use?
              </Form.Label>

              <Form.Control as="select" onChange={(e)=>{
                setAnswers({...answers, friendOrFamilyCommented:e.target.value})
              }}>
                <option>Yes</option>
                <option>No</option>
              </Form.Control>
            </Form.Group>
            <Form.Group controlId="substanceInterference">
              <Form.Label>
              Have you found yourself thinking a lot about drinking or using?
              </Form.Label>

              <Form.Control as="select" onChange={(e)=>{
                setAnswers({...answers, thinkingOfDrinkingOrUsing:e.target.value})
              }}>
                <option>Yes</option>
                <option>No</option>
              </Form.Control>
            </Form.Group>

          </Form>
          <Form.Label> 
           <b>Part 1. </b>
               Listed below are a number of difficult or stressful 
               things that sometimes happen to people. For each 
               event check one or more of the boxes to the right to
               indicate that: (a) it happened to you personally; (b) 
               you witnessed it happen to someone else; (c) you 
               learned about it happening to a close family member 
               or close friend; (d) you were exposed to it as part 
               of your job (for example, paramedic, police, military, 
               or other first responder); (e) you’re not sure if it 
               fits; or (f) it doesn’t apply to you. Be sure to 
               consider your entire life (growing up as well as 
               adulthood) as you go through the list of events. 
 
              </Form.Label>
          <Table responsive="sm">
            <thead>
              <tr>
                <th>Event</th>
                <th>Happened to me</th>
                <th>Witnessed it</th>
                <th>Learned about it</th>
                <th>Part of my job</th>
                <th>Not Sure</th>
                <th>Doesn't Apply</th>
              </tr>
            </thead>
            <tbody>
              <RowHistory
                event={
                  "Natural disaster (for example, flood, hurricane, tornado, earthquake)"
                }
                index={0}
                answers={answers}
                setAnswers={setAnswers}
              />
              <RowHistory 
              event={"Fire or Explosion"} 
              index={1} 
               answers={answers}
               setAnswers={setAnswers}
              />
              <RowHistory
                event={
                  "Transportation accident (for example, car accident, boat accident, train wreck, plane crash)"
                }
                index={2}
                answers={answers}
                setAnswers={setAnswers}
              />
              <RowHistory
                event={
                  "Serious accident at work, home, or during recreational activity"
                }
                index={3}
                answers={answers}
                setAnswers={setAnswers}
              />
              <RowHistory
                event={
                  "Exposure to toxic substance (for example dangerous chemicals radiation)"
                }
                index={4}
                answers={answers}
                setAnswers={setAnswers}
              />
              <RowHistory
                event={
                  "Physical assault (for example, being attacked hit, slapped, kicked and beaten up)"
                }
                index={5}
                answers={answers}
                setAnswers={setAnswers}
              />
              <RowHistory
                event={
                  "Assault with a weapon (for example being shot, stabbed, threatened with a knife, gun bomb)"
                }
                index={6}
                answers={answers}
                setAnswers={setAnswers}
              />
              <RowHistory
                event={
                  "Sexual assault (rape, attempted rape, made to perform any type of sexual act through force or threat of harm)"
                }
                index={7}
                answers={answers}
                setAnswers={setAnswers}
              />
              <RowHistory
                event={"Other unwanted or uncomfortable sexual experience"}
                index={8}
                answers={answers}
                setAnswers={setAnswers}
              />
              <RowHistory
                event={
                  "Combat or exposure to a war-zone (in the military or as a civilian)"
                }
                index={9}
                answers={answers}
                setAnswers={setAnswers}
              />
              <RowHistory
                event={
                  "Captivity (for example being kidnapped abducted, held hostage prisoner of war)"
                }
                index={10}
                answers={answers}
                setAnswers={setAnswers}
              />
              <RowHistory event={"Life Threatening Illness"} index={11} />
              <RowHistory event={"Severe human suffering"} index={12} />
              <RowHistory
                event={"Sudden violent death (of someone you know)"}
                index={13}
                answers={answers}
                setAnswers={setAnswers}
              />
              <RowHistory
                event={"Sudden accidental death (of someone you know)"}
                index={14}
                answers={answers}
                setAnswers={setAnswers}
              />
              <RowHistory
                event={
                  "Serious injury, harm, or death you caused to someone else"
                }
                index={15}
                answers={answers}
                setAnswers={setAnswers}
              />
              <RowHistory
                event={
                  "Any other very stressful event or experience. Briefly identify the event you were thinking of."
                }
                index={16}
                answers={answers}
                setAnswers={setAnswers}
              />
            </tbody>
          </Table>
          <Form>
            <Form.Group controlId="userIncidentDescription">
              <Form.Label>
                <b>Part 2. </b>
                If you have experienced more than one of the events in the
                Part 1, think about the event you consider the worst event,
                which for this questionnaire means the event that currently
                bothers you the most. If you have experienced only one of the
                events in Part 1, use that one as the worst event. Please
                answer the following questions about the worst event (check all
                options that apply):
              </Form.Label>

              <Form.Label>
                Briefly describe the worst event (for example what happened, who
                was involved, etc.)
              </Form.Label>
              <InputGroup>
                <FormControl as="textarea" aria-label="With textarea" />
              </InputGroup>
            </Form.Group>

            <Form.Group controlId="userHowLongAgoDidItHappen">
              <Form.Label>How long ago did it happen?</Form.Label>
              <Form.Control
                type="text"
                placeholder="Please type how long ago it happened"
                onChange={(e)=>{
                  setAnswers({...answers, howLongAgo:e.target.value})
                }} />
              
            </Form.Group>

            <Form.Group controlId="familyStatus">
              <Form.Label>How did you experience it?</Form.Label>
              <Form.Control as="select" onChange={(e)=>{
                setAnswers({...answers, therapy:e.target.value})
              }}>
                <option>It happened to me directly</option>
                <option>I witnessed it</option>
                <option>
                  I learned about it happening to a close family member or
                  friend
                </option>
                <option>
                  I was repeatedly exposed to details about it as part of my job
                </option>
              </Form.Control>
            </Form.Group>

            <Form.Group controlId="familyStatus">
              <Form.Label>Was someone's life in danger</Form.Label>
              <Form.Control as="select" onChange={(e)=>{
                setAnswers({...answers, therapy:e.target.value})
              }}>
                <option>No</option>
                <option>Yes, my life</option>
                <option>Yes, someone else's life.</option>
              </Form.Control>
            </Form.Group>

            <Form.Group controlId="familyStatus">
              <Form.Label>Was someone injured?</Form.Label>
              <Form.Control as="select" onChange={(e)=>{
                setAnswers({...answers, therapy:e.target.value})
              }}>
                <option>No</option>
                <option>Yes, I was seriously injured</option>
                <option>Yes, someone was seriously injured or killed.</option>
              </Form.Control>
            </Form.Group>

            <Form.Group controlId="familyStatus">
              <Form.Label>Did it involve sexual violence?</Form.Label>
              <Form.Control as="select" onChange={(e)=>{
                setAnswers({...answers, therapy:e.target.value})
              }}>
                <option>No</option>
                <option>Yes</option>
              </Form.Control>
            </Form.Group>

            <Form.Group controlId="familyStatus">
              <Form.Label>
                If the event involved the death of a close family member, or
                close friend, was it due to some kind of accident or violence or
                was it due to natural causes?
              </Form.Label>
              <Form.Control as="select" onChange={(e)=>{
                setAnswers({...answers, therapy:e.target.value})
              }}>
                <option>A death was not involved</option>
                <option>Accident or violence</option>
                <option>Natural causes</option>
              </Form.Control>
            </Form.Group>

            <Form.Group controlId="userHowLongAgoDidItHappen">
              <Form.Label>
                How many times have you experienced a similar event as stressful
                or nearly as stressful as the worst event?
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Please type how many times this event has happened"
                onChange={(e)=>{
                  setAnswers({...answers, howManyTimes:e.target.value})
                }} />
              
            </Form.Group>

            <Form.Group controlId="familyStatus">
              <Form.Label>Have you engaged in other therapy?</Form.Label>
              <Form.Control as="select" onChange={(e)=>{
                setAnswers({...answers, therapy:e.target.value})
              }}>
                <option>No</option>
                <option>Cognitive behavioural therapy</option>
                <option>Inter-personal therapy</option>
                <option>Exposure therapy</option>
                <option>Other Therapy</option>
              </Form.Control>
            </Form.Group>

            <button
              onClick={async() => {
                await addJSON({
                  variables: {
                    json: JSON.stringify({
                      answers,
                      startTime,
                      endTime: new Date().toISOString(),
                      type: slide?.type,
                      slide: slide?._slide,
                    }),
                  },
                });
                control.goSlide(slide.complete)
              }}
              type="button"
              className="btn btn-block text-center btn-lg mb-2 btnStandard"
            >
               {slide.complete.title}
            </button>
            <div style={{paddingTop:"50px"}}></div>
          </Form>
        </div>
        
        </Row>
    </>
  );
};

export default PatientHistory;
